// extracted by mini-css-extract-plugin
module.exports = {"preview":"preview_preview__39iFf","posi":"preview_posi__2-Ybc","posiP":"preview_posiP__f-E9M","myfirst":"preview_myfirst__1enSO","img":"preview_img__2P209"};